import { useMutation } from '@tanstack/react-query';
import { revokeAllTokens } from '../api/users';

export function useRevokeAllTokens() {
  return useMutation({
    mutationFn: (userId: string) => revokeAllTokens(userId),
  });
}
